/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React from "react";
import {
    Button,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    Typography,
} from "@mui/material";
import ZahlungsmethodeAendernDialog from "../../../Management/Mandanten/Views/ZahlungsmethodeAendernDialog";
import { environment } from "../../environment";
import { XIcon } from "../../FontAwesome";
import { translationKeys, useTranslation } from "../../Internationalisierung/i18nBasis";
import Secure from "../../Utils/Secure";
import { useAppMandantContext } from "../AppMandantContext";
import { useAppRollenContext } from "../AppRollenContext";
import DialogBase from "../DialogBase";
import StripeElements from "../StripeElements";

export default function AppZahlungsmethodeSetzenDialog() {
    const { t } = useTranslation();
    const [open, setOpen] = React.useState<boolean>(false);
    const [zahlungsmethodeAendernIsOpen, setZahlungsmethodeAendernIsOpen] = React.useState<boolean>(false);
    const appMandantContext = useAppMandantContext();
    const appRollenContext = useAppRollenContext();
    const istNutzend = appRollenContext.istNutzend;
    const istBuchungsportal = environment.istBuchungsportal;
    const mandant = appMandantContext.mandant;

    Secure.useEffect((secure) => {
        if (istBuchungsportal || !istNutzend || !mandant) {
            return;
        }

        secure(setOpen)(mandant.istZahlungsmethodeBisUeberschritten);
    }, [istNutzend, istBuchungsportal, mandant])

    function handleSchliessen() {
        setOpen(false);
    }

    function handleZahlungsmethodeSetzen() {
        setZahlungsmethodeAendernIsOpen(true);
    }

    return (
        <DialogBase open={open} scroll="body">
            <DialogTitle
                sx={{
                    margin: 0,
                    padding: 2,
                    position: "relative",
                }}
            >
                <Typography variant="h6">
                    {t(translationKeys.appZahlungsmethodeSetzenDialog.title)}
                </Typography>
                <IconButton
                    aria-label={t(translationKeys.appZahlungsmethodeSetzenDialog.schliessen)}
                    sx={{
                        position: "absolute",
                        right: (theme) => theme.spacing(),
                        top: (theme) => theme.spacing()
                    }}
                    onClick={handleSchliessen}
                    size="large"
                >
                    <XIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent sx={{ px: 2, py: 0 }}>
                <Typography gutterBottom>
                    {t(translationKeys.appZahlungsmethodeSetzenDialog.text)}
                </Typography>
            </DialogContent>
            <DialogActions sx={{ m: 0, p: 1 }}>
                <Button color="primary" onClick={handleZahlungsmethodeSetzen}>
                    {t(translationKeys.appZahlungsmethodeSetzenDialog.zahlungsmethodeSetzen)}
                </Button>
                <Button color="primary" onClick={handleSchliessen}>
                    {t(translationKeys.appZahlungsmethodeSetzenDialog.schliessen)}
                </Button>
            </DialogActions>
            <StripeElements>
                <ZahlungsmethodeAendernDialog
                    isOpen={zahlungsmethodeAendernIsOpen}
                    mandantId={mandant?.mandantId ?? ""}
                    mandantGeaendert={mandant?.geaendert ?? ""}
                    onGespeichert={() => {
                        setZahlungsmethodeAendernIsOpen(false);
                        window.location.reload();
                    }}
                    onAbgebrochen={() => {
                        setZahlungsmethodeAendernIsOpen(false);
                        handleSchliessen();
                    }}
                    hatBereitsZahlungsmethode={false}
                />
            </StripeElements>
        </DialogBase>
    );
}
